import { makeAutoObservable } from 'mobx';
import { Airport } from './airport';

class PopupManager {
  populationIncreaseEvent: { airport: Airport; message: string } | null = null;
  offlineIncomeCollect: { money: number; isX2: boolean } | null = null;

  airportFullPopupTimer: number | null = null;
  airportFull: { airport: Airport } | null = null;
  advanceCongrats: boolean = false;
  rewardedVideoErrorPopup: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  showPopulationIncreaseEvent(airport: Airport, message: string) {
    this.populationIncreaseEvent = { airport, message };
    setTimeout(() => {
      this.clearPopuplationIncreaseEvent();
    }, 10000);
  }

  clearPopuplationIncreaseEvent() {
    this.populationIncreaseEvent = null;
  }

  showAirportFull(airport: Airport) {
    if (this.airportFullPopupTimer) {
      window.clearTimeout(this.airportFullPopupTimer);
    }
    this.airportFull = { airport };
    this.airportFullPopupTimer = window.setTimeout(() => {
      this.clearAirportFull();
    }, 3000);
  }

  clearAirportFull() {
    this.airportFull = null;
  }

  showAdvanceCongrats() {
    this.advanceCongrats = true;
    this.airportFullPopupTimer = window.setTimeout(() => {
      this.clearAdvanceCongrats();
    }, 10000);
  }

  clearAdvanceCongrats() {
    this.advanceCongrats = false;
  }

  showRewardedVideoErrorPopup() {
    this.rewardedVideoErrorPopup = true;
    setTimeout(() => {
      this.clearRewardedVideoErrorPopup();
    }, 5000);
  }

  clearRewardedVideoErrorPopup() {
    this.rewardedVideoErrorPopup = false;
  }

  showOfflineIncomeCollect(money: number, isX2: boolean) {
    this.offlineIncomeCollect = { money, isX2 };
    window.setTimeout(() => {
      this.clearOfflineIncomeCollect();
    }, 5000);
  }

  clearOfflineIncomeCollect() {
    this.offlineIncomeCollect = null;
  }

  clearAll() {
    this.populationIncreaseEvent = null;
    this.airportFull = null;
    this.rewardedVideoErrorPopup = false;
    this.offlineIncomeCollect = null;
  }
}

export const POPUP = new PopupManager();
